export default __webpack_public_path__ + "static/media/9.fc2c4131.jpg";